/**
 * 历史菜单导入/导出文件名：<人均餐标>-<就餐人数>，例如 300-8
 * 若文件名里有多段数字，取最后一段「餐标-人数」（避免 2026-09-15-300-12 被识别成 2026-09）
 */

export function parseHistoryFileName(fileName) {
  const base = String(fileName || '')
    .replace(/^.*[\\/]/, '')
    .replace(/\.[^.]+$/, '')
    .trim()
  const exact = base.match(/^(\d+(?:\.\d+)?)-(\d+)$/)
  let matched = exact
  if (!matched) {
    const all = []
    const re = /(\d+(?:\.\d+)?)-(\d+)/g
    let m = re.exec(base)
    while (m) {
      all.push(m)
      m = re.exec(base)
    }
    matched = all.length ? all[all.length - 1] : null
  }
  if (!matched) return null
  const perCapita = Number(matched[1])
  const guestCount = Number(matched[2])
  if (!Number.isFinite(perCapita) || perCapita <= 0) return null
  if (!Number.isInteger(guestCount) || guestCount < 1) return null
  return { perCapita, guestCount }
}

export function buildHistoryFileStem(perCapita, guestCount) {
  const p = Number(perCapita)
  const cap = Number.isInteger(p) ? String(p) : String(p)
  return `${cap}-${Number(guestCount) || 0}`
}
